import { TemplateRef } from '@angular/core';
import { ApiService } from '../../../services/api.service';
import { CUSTOMER_TYPES } from '../../../services/constant';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as validate from 'validate.js';
var CustomerDetailComponent = (function () {
    function CustomerDetailComponent(apiService, modalService) {
        this.apiService = apiService;
        this.modalService = modalService;
        this.parent = null;
        this.customerTypes = CUSTOMER_TYPES.map(function (obj) { return ({ label: obj.name, value: obj.value }); });
        this.data = {
            id: null,
            buyerType: null,
            name: '',
            customerID: '',
            taxID: '',
            branchName: '',
            branchCode: [],
            headOffice: false,
            address: '',
            postCode: '',
            country: null,
            phoneNumber: '',
            email: ''
        };
        this.isCreate = true;
        this.constraints = {
            general: {
                buyerType: {
                    presence: true
                },
                name: {
                    presence: { allowEmpty: false }
                },
                headOffice: {
                    presence: true
                },
                branchName: function (value, attributes, attributeName, options, constraints) {
                    if (attributes.headOffice === false) {
                        return {
                            presence: { allowEmpty: true }
                        };
                    }
                    return null;
                },
                address: {
                    presence: { allowEmpty: false }
                },
                postCode: {
                    presence: { allowEmpty: false }
                },
            },
            foreign: {
                country: {
                    presence: true
                },
                taxID: {
                    presence: {
                        message: '^Passport number can\'t be blank'
                    },
                    numericality: {
                        onlyInteger: true,
                        message: '^Passport number is not a valid number'
                    }
                },
            },
            domestic: {
                branchCode: {
                    presence: true
                },
            },
            notForeign: {
                taxID: {
                    presence: true,
                    numericality: { onlyInteger: true },
                    length: { is: 13 }
                },
            }
        };
    }
    CustomerDetailComponent.prototype.open = function (parent, buyerType, buyer) {
        this.parent = parent;
        this.data.buyerType = buyerType.value;
        if (buyer) {
            this.isCreate = false;
            Object.assign(this.data, {
                id: buyer.id,
                // buyerType: buyer.buyer_type,
                name: buyer.name,
                customerID: buyer.customer_id,
                taxID: buyer.tax_id,
                address: buyer.address,
                branchCode: buyer.branch_code,
                country: buyer.country_code,
                postCode: buyer.post_code,
                phoneNumber: buyer.phone_number,
                email: buyer.email
            });
        }
        this.modal = this.modalService.open(this.modalTemplate, { size: 'lg' });
    };
    CustomerDetailComponent.prototype.ngOnInit = function () {
        this.loadCountry();
    };
    Object.defineProperty(CustomerDetailComponent.prototype, "isForeignCorporation", {
        get: function () {
            return this.data.buyerType === 1;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CustomerDetailComponent.prototype, "isDomesticCorporation", {
        get: function () {
            return [0, 3].indexOf(this.data.buyerType) !== -1;
        },
        enumerable: true,
        configurable: true
    });
    CustomerDetailComponent.prototype.loadCountry = function () {
        var _this = this;
        this.apiService.getCountry().subscribe(function (res) {
            _this.countryList = res.map(function (obj) { return ({
                label: obj.country_name,
                value: obj.country_code
            }); });
        }, function (err) {
            console.log(err);
        });
    };
    CustomerDetailComponent.prototype.validate = function () {
        var buyerConstraints = validate.extend({}, this.constraints.general);
        if (this.isForeignCorporation) {
            validate.extend(buyerConstraints, this.constraints.foreign);
        }
        if (this.isDomesticCorporation) {
            validate.extend(buyerConstraints, this.constraints.domestic);
        }
        if (this.data.taxID) {
            if (this.data.taxID.length === 13) {
                this.errorTaxID = null;
            }
            else if ((typeof (this.data.taxID)) === 'object') {
                this.errorTaxID = null;
            }
            else {
                this.errorTaxID = 'Buyer Taxi ID should be 13 digits or blank';
            }
        }
        else {
            this.data.taxID = null;
        }
        this.errors = validate(this.data, buyerConstraints);
    };
    CustomerDetailComponent.prototype.submit = function () {
        var _this = this;
        this.errorTaxID = null;
        this.errors = null;
        this.validate();
        if (this.errors || this.errorTaxID) {
            return;
        }
        var data = {
            name: this.data.name,
            customer_id: this.data.customerID,
            tax_id: this.data.taxID,
            address: this.data.address,
            branch_code: this.data.branchCode.toString(),
            post_code: this.data.postCode,
            country_code: this.data.country,
            email: this.data.email,
            buyer_type: this.data.buyerType
        };
        // data depended on customer type
        if (this.isForeignCorporation) {
            data['country_code'] = this.data.country;
        }
        if (this.isDomesticCorporation) {
            data['branchCode'] = this.data.branchCode.toString();
        }
        // get API by operation
        var api = null;
        if (this.isCreate) {
            api = this.apiService.createBuyerBranch(data);
        }
        else {
            api = this.apiService.updateBuyerBranch(this.data.id, data);
        }
        api.subscribe(function () {
            _this.modal.close();
            _this.sniff('UPDATE_CUST_DATA', '');
            _this.parent.loadData();
        }, function (err) {
            console.log(err);
        });
    };
    CustomerDetailComponent.prototype.sniff = function (action, target) {
        var data = {
            action: action,
            address: 'CUS_INFO',
            target: target
        };
        this.apiService.sniff(data).subscribe(function (res) {
        });
    };
    return CustomerDetailComponent;
}());
export { CustomerDetailComponent };



// WEBPACK FOOTER //
// /opt/app/src/app/features/customer/customer-detail/customer-detail.component.ts.pre-build-optimizer.js